import { RankedModeTypes } from '../../../../shared/GameEnums.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { clientI18n, clientIntl } from '../ClientI18n.ts';
export function createLeaderboardsPageDataDeps(options) {
    const { manageHistory } = options;
    return {
        requestTabs: async (leaderboardUrl)=>{
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiLeaderboards.tabs(leaderboardUrl), undefined);
            if (response == undefined) return undefined;
            return response.json;
        },
        requestStickyRow: async (mode, leaderboardUrl)=>{
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiLeaderboards.stickyRowData(RankedModeTypes[mode], leaderboardUrl), undefined);
            if (response == undefined) return undefined;
            const stickyRow = response.json;
            return stickyRow == '' ? undefined : stickyRow;
        },
        requestScrollData: async (mode, leaderboardUrl, start, end, search)=>{
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiLeaderboards.data(RankedModeTypes[mode], leaderboardUrl), undefined, {
                start: start,
                end: end,
                search: search
            });
            if (response == undefined) return undefined;
            return response.json;
        },
        requestSearchData: async (mode, leaderboardUrl, search)=>{
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiLeaderboards.usernameSearch(RankedModeTypes[mode], leaderboardUrl), undefined, {
                usernameSearchInput: search
            });
            if (response == undefined) return undefined;
            return response.json;
        },
        getCurrentUrl: ()=>manageHistory ? `${window.location.pathname}${window.location.search}` : '',
        pushHistoryState: manageHistory ? (state, url)=>history.pushState(state, '', url) : ()=>undefined,
        updateBrowserTitle: manageHistory ? (mode, leaderboardUrl)=>{
            const urlPart = leaderboardUrl ? `/${leaderboardUrl}` : '';
            const pageName = `${RankedModeTypes[mode]}${urlPart}`;
            document.title = clientI18n.t('strings:leaderboardPage.pageHeadInfo.title', {
                pageName: pageName,
                interpolation: {
                    escapeValue: false
                }
            });
        } : ()=>undefined,
        subscribePopState: manageHistory ? (handler)=>{
            const listener = (event)=>handler(event.state);
            window.addEventListener('popstate', listener);
            return ()=>window.removeEventListener('popstate', listener);
        } : ()=>()=>undefined,
        getLanguagePathPrefix: ()=>clientIntl.getLanguagePathPrefix()
    };
}
